/*for the forc click event trigger on products having customly app applied*/

document.addEventListener('DOMContentLoaded', function () {
    document.getElementById('trigger-button').addEventListener('click', function () {
        // Add a class to the trigger-button
        this.classList.add('disabled');
        
        // Trigger the click event on the customily-cart-btn
        const customilyButton = document.getElementById('customily-cart-btn');
        if (customilyButton) {
            customilyButton.click();
        } else {
            alert('customily-cart-btn not found');
        }
    });
});



/*for the product page option apened in title section*/


document.addEventListener('DOMContentLoaded', () => {
  const productTitle = document.querySelector('.product-title'); // Adjust selector for product title
  const hideScrollbarDivs = document.querySelectorAll('.rio-hide-scrollbar'); // Get all divs to listen for clicks
  const optionValues = document.querySelectorAll('.rio-product-option-title-option-value'); // Options to fetch values

  if (productTitle && hideScrollbarDivs.length > 0) {
      hideScrollbarDivs.forEach(hideScrollbarDiv => {
          hideScrollbarDiv.addEventListener('click', () => {
              // Get the text content from all option values
              const selectedOptions = Array.from(optionValues)
                  .map(option => option.textContent.trim())
                  .filter(value => value) // Filter out empty values
                  .join(', ');

              // Remove existing appended content
              const existingOption = productTitle.querySelector('.product-option-append');
              if (existingOption) {
                  existingOption.remove();
              }

              // Append the selected options to the product title
              if (selectedOptions) {
                  const htmlToAppend = `<span class="product-option-append"> - ${selectedOptions}</span>`;
                  productTitle.insertAdjacentHTML('beforeend', htmlToAppend);
              }
          });
      });
  }
});


/*for the cart page delteing the extra charges with the deletion of product*/

document.addEventListener("click", function (event) {
    let clickedButton = event.target.closest("cart-remove-button .button");
    if (clickedButton) {
        let currentRow = clickedButton.closest("tr"); // Get the current row
        let nextRow = currentRow.nextElementSibling; // Get the next row

        // Skip the row if it has class "Gift-Box" and check the next one
        if (nextRow && nextRow.classList.contains("Gift-Box")) {
            nextRow = nextRow.nextElementSibling; // Move to the next row after "Gift-Box"
        }

        // If a valid row exists after skipping "Gift-Box"
        if (nextRow) {
            let hiddenQuantity = nextRow.querySelector(".cart-item__quantity");

            if (hiddenQuantity && getComputedStyle(hiddenQuantity).visibility === "hidden") {
                let nextRowId = nextRow.getAttribute("id"); // Get the ID of next row

                // Click the delete button of the current row
                clickedButton.click();

                // Wait for deletion, then find and delete the next row using its ID
                setTimeout(() => {
                    // Extract the last digit, decrease it by 1, and create the new ID
                    let lastDigit = parseInt(nextRowId.charAt(nextRowId.length - 1)); // Get the last digit
                    let newLastDigit = lastDigit - 1; // Reduce the last digit by 1

                    // Create the new ID by replacing the last digit with the decremented value
                    let newNextRowId = nextRowId.slice(0, -1) + newLastDigit;

                    let targetRow = document.getElementById(newNextRowId);

                    if (targetRow) {
                        let nextRemoveButton = targetRow.querySelector("cart-remove-button .button");
                        if (nextRemoveButton) nextRemoveButton.click();
                    }
                }, 2000); // Delay to allow first row to be removed
            } else {
                clickedButton.click(); // Delete only the current row if condition isn't met
            }
        } else {
            clickedButton.click(); // Delete only the current row if no valid next row exists
        }
    }
});




/*for the cart page grouping the gift box product with its presnt product in single tbody and remove gift box if product get deleted*/

/*document.addEventListener("DOMContentLoaded", function () {
    console.log("Cart script running...");

    let cartTable = document.querySelector("table.cart-items");
    if (!cartTable) {
        console.log("Cart table not found.");
        return;
    }

    let cartBody = cartTable.querySelector("tbody");
    if (!cartBody) {
        console.log("Cart tbody not found.");
        return;
    }

    let productRows = [...cartBody.querySelectorAll("tr[data-product-name]")];

    if (productRows.length === 0) {
        console.log("No product rows found.");
        return;
    }

    let groupedProducts = {};

    // Step 1: Group cart items by product name
    productRows.forEach(row => {
        let productName = row.getAttribute("data-product-name");

        if (!groupedProducts[productName]) {
            groupedProducts[productName] = [];
        }

        groupedProducts[productName].push(row);
    });

    // Step 2: Clear the original cartBody
    cartBody.innerHTML = '';

    // Step 3: Append grouped products inside their own <tbody>
    Object.keys(groupedProducts).forEach(productName => {
        let rows = groupedProducts[productName];

        if (rows.length > 1) {
            console.log(`Grouping ${rows.length} items of: ${productName}`);

            // Create a new <tbody> for grouped products
            let groupedTbody = document.createElement("tbody");
            groupedTbody.classList.add("cart-grouped-product");
            groupedTbody.setAttribute("data-product-name", productName);

            // Append all rows inside this new tbody
            rows.forEach(row => {
                groupedTbody.appendChild(row);
            });

            // Append the new grouped tbody to the main cart table
            cartTable.appendChild(groupedTbody);
        } else {
            // If only one row, append it back normally
            cartBody.appendChild(rows[0]);
        }
    });

    console.log("Cart items successfully grouped.");

    // Step 4: Show loader before cart actions
    function showLoader() {
        let loader = document.createElement("div");
        loader.id = "cart-loader";
        loader.style.position = "fixed";
        loader.style.top = "0";
        loader.style.left = "0";
        loader.style.width = "100%";
        loader.style.height = "100%";
        loader.style.background = "rgba(255, 255, 255, 0.7)";
        loader.style.display = "flex";
        loader.style.alignItems = "center";
        loader.style.justifyContent = "center";
        loader.style.fontSize = "20px";
        loader.style.fontWeight = "bold";
        loader.innerText = "Updating Cart...";
        document.body.appendChild(loader);
    }

    function hideLoader() {
        let loader = document.getElementById("cart-loader");
        if (loader) loader.remove();
    }

    // Step 5: Automatically remove "Gift-Box" if inside "cart-solo-products"
    let giftBoxRow = document.querySelector("tbody.cart-solo-products tr.Gift-Box");
    if (giftBoxRow) {
        console.log("Detected Gift-Box inside cart-solo-products. Triggering removal...");
        let removeButton = giftBoxRow.querySelector("cart-remove-button a.button.button--tertiary");

        console.log("removeButton")

        if (removeButton) {
            showLoader(); // Show loader before clicking
            setTimeout(() => {
                removeButton.click(); // Trigger click using ID
            }, 1000);
            hideLoader(); // hide loader after clicking
        }
    }
});*/